<template>
  <div class="container">
    <div class="login-modal" id="loginModal" tabindex="-1" role="dialog" aria-labelledby="login" aria-hidden="true" >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <img src="/assets/img/svg/key.svg" alt="Login" />
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="logout-form text-center">
                <span class="h3">Logout in corso</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import notificator from '../../mixins/notificator';

export default {
  mixins: [notificator],

  created() {
    this.$store.dispatch("logout").then(response => {
      this.notify(this.$options.filters.notification({endpoint: 'Logout', code: 200, response: response}));      
    });
  }
};
</script>

